import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Stack,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { AgGridReact } from "ag-grid-react";
import {
  UploadCsvDataColumn,
  UploadCsvDealerDataColumn,
} from "../common/constants/gridRowColumn";
import "ag-grid-community/styles/ag-theme-quartz.css";
import "ag-grid-community/styles/ag-grid.css";
import sampleCSV from "../assets/csv/SampleFleetList.csv";
import {
  useCompany,
  useDealer,
  useDriveTrain,
  useFuelList,
  useModel,
  useTypeList,
  useUser,
} from "../common/hooks";
import { checkbox, typeConstant, ensureHeaderTooltip } from "../common/constants/commonFunction";
import { PopupMessage } from "../common/constants/popupMessage";
import { CsvUploadErrors } from "../common/constants/csvUploadError";
import { showToast } from "./Toast";
import {
  csvFileToArray,
  escapeSpecialChars,
  escapeSpecialCharsCompany,
  xlsxFileToArray,
} from "../common/utils/excelUpload";
import { SelectedModels } from "./SelectedModels";
import { FleetUploadConformDialog } from "./FleetUploadConformDialog";
import { localStorageItemNames } from "../common/constants";
import { DEALEAR_DEFAULT } from "../common/constants/dealer-name";

export const FleetCsvUpload = ({
  handleClose,
  open,
  classes,
  defaultColDef,
  handleRowSelection,
  addButtonDisabled,
  setRowDataCsv,
  columnFinal,
  setAddButtonDisabled,
  rows,
  setRows,
  file,
  setFile,
  uploadType,
}) => {
  const {
    closetMatchModel,
    selectClosetModel,
    setSelectClosetModel,
    newRowData,
    setNewRowData,
    newRowIndexData,
    isClosetModel,
    setSelectedModel,
  } = useModel();

  const cellEditorSelector = (params) => {
    return {
      component: SelectedModels,
    };
  };

  const {
    loadingFleetFile,
    uploadCSVDealerApi,
    checkDealerNameApi,
    checkDealerNameLoading,
    matchDealerName,
  } = useDealer();
  const { fuelList, getFuelListApi } = useFuelList();
  const { driveTrainList, getDriveTrainListApi } = useDriveTrain();
  const { typeList, getTypeListApi } = useTypeList();
  const { model, getModel } = useModel();
  const { user, getUser } = useUser();
  const [columns, setColumns] = useState([]);
  const [columnFinal1, setColumnFinal1] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectIndex, setSelectIndex] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [openDealerName, setOpenDealerName] = useState(false);
  const [rowChangeField, setRowChangeField] = useState();
  const [openAdd, setOpenAdd] = useState(false);
  const [containerRef, setContainerRef] = useState(null);
  const { dealerNameHeader } = useCompany();
  const typeUser = localStorage.getItem("type");
  const [selectedUserId, setSelectedUserId] = useState("");
  const [showUserDropdown, setShowUserDropdown] = useState(false);

  const [dragActive, setDragActive] = useState(false);

  useEffect(() => {
    if (columns?.length > 0) {
      columns?.map((item) => {
        item["width"] = 160;
        return true;
      });
    }
  }, [columns]);

  useEffect(() => {
    if (isClosetModel) {
      newRowData?.map((items) => {
        isClosetModel?.map((item) => {
          if (items?.id == item?.id) {
            items["selectedModelRow"] = item?.selectedModelRow;
          }
        });
      });
      setNewRowData(newRowData);
    }
  }, [isClosetModel]);
  useEffect(() => {
    let actionColumn = {
      headerName: "Closest Match Models",
      field: "language",
      cellRenderer: SelectedModels,
      cellEditor: "agRichSelectCellEditor",
      cellEditorParams: {
        dataValue: newRowData,
        cellRenderer: SelectedModels,
      },
    };
    let dealerColumn = {};
    if (matchDealerName && matchDealerName?.length > 0) {
      dealerColumn = {
        field: "dealer",
        headerName: "Dealer",
        headerClassName: "matchDealerName",
        editable: true,
      };
    } else {
      dealerColumn = {
        field: "dealer",
        headerName: "Dealer",
        headerClassName: "super-app-theme--header",
        editable: true,
      };
    }
    let updatedColumnDefs = UploadCsvDataColumn.map((column) => ({
      ...column,
      cellClass: column?.cellClass,
    }));

    setColumnFinal1([checkbox, ...updatedColumnDefs]);

  }, [
    newRowData,
    UploadCsvDataColumn,
    isClosetModel,
    matchDealerName,
    rowChangeField,
  ]);

  useEffect(() => {
    newRowData?.map((item, index) => {
      item["id"] = index + 1;
    });
    if (newRowData?.length > 0) {
      closetMatchModel(newRowData);
    }
  }, [newRowData]);

  const handleOnChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFile(e.target.files[0]);
    }
  };

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const droppedFile = e.dataTransfer.files[0];
      const fileType = droppedFile.name.split(".").pop().toLowerCase();
      if (["csv", "xlsx", "xls"].includes(fileType)) {
        setFile(droppedFile);
      } else {
        showToast("Unsupported file type. Please upload CSV or XLSX/XLS.");
      }
    }
  };

  const downloadCsv = () => {
    const link = document.createElement("a");
    link.href = sampleCSV;
    link.setAttribute("download", "Sample Current Fleet Details.csv");

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
  };

  const handleCellValueChanged = (event) => {
    const newValue = event.newValue;
    const rowData = event.data;
    const field = event.colDef.field;
    setRowChangeField({ field: field, data: rowData });
  };

  useEffect(() => {
    getFuelListApi();
    getTypeListApi();
    setSelectedModel(null);
  }, []);

  useEffect(() => {
    if (open && typeUser === typeConstant.admin) {
      getUser();
    }
  }, [open, typeUser]);

  useEffect(() => {
    if (!open) {
      setSelectedUserId("");
      setShowUserDropdown(false);
    }
  }, [open]);

  const handleAddButton = async (e) => {
    e.stopPropagation();
    setAddButtonDisabled(true);
    if (!file) {
      showToast(PopupMessage.selectFile);
      return;
    }
    let { rowData, error } = await CsvUploadErrors(newRowData, columnFinal);
    rowData?.map((items, index) => {
      fuelList?.map((item) => {
        if (item?.name === items?.fuel) {
          rowData[index].fuelId = item?.id;
        }
      });
    });
    rowData?.map((items, index) => {
      driveTrainList?.map((item) => {
        if (item?.name === items?.driveTrain) {
          rowData[index].driveTrainId = item?.id;
        }
      });
    });
    rowData?.map((items, index) => {
      typeList?.map((item) => {
        if (
          item?.name?.trim()?.toLowerCase() ===
          items?.type?.toString()?.trim()?.toLowerCase()
        ) {
          rowData[index].typeId = item?.id;
          rowData[index].type = item?.name;
        }
      });
    });
    let vinNumber = [];
    setRowDataCsv(rowData);
    if (error?.length == 0) {
      let typeId;
      let type = localStorage.getItem("type");
      if (type === typeConstant.dealer) {
        typeId = localStorage.getItem("typeId");
      }
      let payload;
      const finalUserId = (typeUser === typeConstant.admin && selectedUserId)
        ? selectedUserId
        : localStorage.getItem(localStorageItemNames.userID);

      const newDataRow = escapeSpecialCharsCompany(rowData);
      const filteredDataRow = newDataRow.map((item) => {
        item["dealer"] = DEALEAR_DEFAULT.dealerName;
        item["userId"] = finalUserId;
        item["fleetType"] = uploadType;
        return item;
      });
      payload = {
        dealerId: DEALEAR_DEFAULT.dealerId,
        userId: finalUserId,
        fleetType: uploadType,
        data: filteredDataRow,
      };
      newDataRow?.map((items) => {
        if (!items?.selectedModel) {
          items["selectedModel"] = "";
        } else {
          items["selectedModel"] = items?.selectedModel?.model
            ? items?.selectedModel?.model
            : items?.selectedModel;
        }
      });
      if (vinNumber?.length > 0) {
        const error = vinNumber;
        const errorMessage = error
          .map(
            (error) =>
              `Line ${error.lineNumber}: VIN ${error.vin} is not valid.`
          )
          .join("\n");
        showToast(errorMessage);
        setAddButtonDisabled(false);
        return;
      } else {
        showToast(PopupMessage.uploadFile);
        await uploadCSVDealerApi(payload);
        setRowDataCsv([]);
        setSelectClosetModel("");
        setAddButtonDisabled(false);
      }
    }
  };
  const fileToArray = async (file, type) => {
    if (type === "csv") {
      const text = await file.text();
      return csvFileToArray(text);
    } else if (type === "xlsx") {
      return xlsxFileToArray(file);
    } else {
      throw new Error("Unsupported file type");
    }
  };
  useEffect(() => {
    if (file) {
      const fileType = file.name.split(".").pop().toLowerCase();
      let type = "";
      if (fileType === "csv") {
        type = "csv";
      } else if (["xlsx", "xls"].includes(fileType)) {
        type = "xlsx";
      }

      fileToArray(file, type)
        .then(({ data, headers }) => {
          setRows(data);
          setNewRowData(data);
          setColumns(
            headers.map((header) => ({ field: header, headerName: header }))
          );
        })
        .catch((error) => console.error("Error processing file:", error));
    } else {
      setRows([]);
      setNewRowData([]);
      setColumns([]);
    }
  }, [file]);
  const frameworkComponents = {
    selectedModels: SelectedModels,
  };

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const goToRowIndex = (index) => {
    if (gridApi) {
      let indexValue = index == null ? 0 : index;
      gridApi.ensureIndexVisible(indexValue, "middle");
    }
  };
  const onFirstDataRendered = () => {
    goToRowIndex(newRowIndexData);
  };

  useEffect(() => {
    if (newRowIndexData) {
      goToRowIndex(newRowIndexData);
    }
  }, [newRowData, newRowIndexData]);

  useEffect(() => {
    if (
      newRowData &&
      newRowData?.length > 0 &&
      typeUser === typeConstant.admin
    ) {
      checkDealerNameApi({ dealerName: newRowData[0]?.dealer });
    }
  }, [newRowData, columnFinal, rowChangeField]);

  useEffect(() => {
    if (rowChangeField?.data && rowChangeField?.field == "dealer") {
      const dataNew = newRowData?.map((item) => {
        item["dealer"] = rowChangeField?.data?.dealer;
        return item;
      });
      setNewRowData(dataNew);
    }
  }, [rowChangeField]);

  const handleCheckDealerName = () => {
    setOpenDealerName(true);
  };
  const handleDealerNameClose = () => {
    setOpenDealerName(false);
  };
  const handleAddBox = () => {
    setOpenAdd(true);
  };
  const handleDealerAddBox = () => {
    setOpenAdd(true);
  };
  return (
    <>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        maxWidth="xl"
        fullWidth
        PaperProps={{
          sx: (theme) => ({
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
            borderRadius: "16px",
            border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(148,163,184,0.12)' : 'rgba(160, 198, 232, 0.35)'}`,
            boxShadow: theme.palette.mode === 'dark' ? '0 16px 40px rgba(0,0,0,0.6)' : '0 16px 40px rgba(2, 6, 23, 0.08)',
            maxHeight: "92vh",
            height: "85vh",
            display: "flex",
            flexDirection: "column",
          })
        }}
      >
        <DialogTitle
          id="customized-dialog-title"
          sx={(theme) => ({
            m: 0,
            p: 2.5,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: `1px solid ${theme.palette.divider}`,
            backgroundColor: theme.palette.background.paper,
          })}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Typography
              variant="h6"
              component="span"
              sx={(theme) => ({ fontWeight: 700, color: theme.palette.primary.main, letterSpacing: "0.5px" })}
            >
              Upload Fleet CSV / XLSX
            </Typography>
            {uploadType && (
              <Box
                sx={(theme) => ({
                  background: theme.palette.mode === 'dark' ? 'rgba(29, 78, 216, 0.15)' : 'rgba(29, 78, 216, 0.1)',
                  color: theme.palette.primary.main,
                  border: `1px solid ${theme.palette.primary.light}`,
                  borderRadius: "20px",
                  px: 1.5,
                  py: 0.25,
                  fontSize: "12px",
                  fontWeight: 700,
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                })}
              >
                {uploadType}
              </Box>
            )}
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            {typeUser === typeConstant.admin && (
              <>
                {!showUserDropdown ? (
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setShowUserDropdown(true)}
                    sx={(theme) => ({
                      textTransform: "none",
                      borderRadius: "8px",
                      fontWeight: 600,
                      px: 2,
                      borderColor: theme.palette.primary.main,
                      color: theme.palette.primary.main,
                      "&:hover": {
                        borderColor: theme.palette.primary.dark,
                        backgroundColor: theme.palette.action.hover,
                      },
                    })}
                  >
                    Add User to Fleet
                  </Button>
                ) : (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <FormControl size="small" sx={{ minWidth: 200 }}>
                      <InputLabel id="select-user-label">Select User</InputLabel>
                      <Select
                        labelId="select-user-label"
                        id="select-user"
                        value={selectedUserId}
                        label="Select User"
                        onChange={(e) => setSelectedUserId(e.target.value)}
                        sx={{ borderRadius: "8px" }}
                      >
                        <MenuItem value="">
                          <em>None (Use default)</em>
                        </MenuItem>
                        {user &&
                          user.map((u) => (
                            <MenuItem key={u.id} value={u.id}>
                              {u.name
                                ? `${u.name} (${u.userName || u.email})`
                                : u.userName || u.email}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                    <IconButton
                      size="small"
                      onClick={() => {
                        setShowUserDropdown(false);
                        setSelectedUserId("");
                      }}
                      sx={(theme) => ({
                        color: theme.palette.text.secondary,
                        "&:hover": {
                          color: theme.palette.error.main,
                          backgroundColor: theme.palette.action.hover,
                        },
                      })}
                      title="Clear Selection"
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </Box>
                )}
              </>
            )}
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={(theme) => ({
                color: theme.palette.text.secondary,
                "&:hover": {
                  color: theme.palette.primary.main,
                  backgroundColor: theme.palette.action.hover,
                },
              })}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent
          sx={(theme) => ({
            flex: 1,
            display: "flex",
            flexDirection: "column",
            p: 3,
            backgroundColor: theme.palette.background.paper,
            overflow: "hidden",
          })}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              alignItems: "stretch",
              justifyContent: "space-between",
              gap: 3,
              mb: 3,
            }}
          >
            {/* Drag & Drop Upload Zone */}
            <Box
              onDragEnter={handleDrag}
              onDragOver={handleDrag}
              onDragLeave={handleDrag}
              onDrop={handleDrop}
              sx={(theme) => ({
                flex: 1,
                border: "2px dashed",
                borderColor: dragActive ? theme.palette.primary.main : theme.palette.divider,
                borderRadius: "12px",
                backgroundColor: dragActive
                  ? theme.palette.mode === 'dark'
                    ? 'rgba(32, 141, 233, 0.18)'
                    : 'rgba(32, 141, 233, 0.08)'
                  : theme.palette.background.default,
                p: file ? 2.5 : 4,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                cursor: "pointer",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                position: "relative",
                minHeight: "140px",
                "&:hover": {
                  borderColor: theme.palette.primary.main,
                  backgroundColor: theme.palette.action.hover,
                  boxShadow: theme.palette.mode === 'dark'
                    ? "0 0 20px rgba(32, 141, 233, 0.16) inset"
                    : "0 0 20px rgba(32, 141, 233, 0.08) inset",
                },
              })}
            >
              <input
                id="filePicker"
                accept=".csv, .xlsx, .xls"
                onChange={handleOnChange}
                style={{
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  top: 0,
                  left: 0,
                  opacity: 0,
                  cursor: "pointer",
                  zIndex: 2,
                }}
                type={"file"}
              />

              {!file ? (
                <>
                  <CloudUploadIcon sx={(theme) => ({ fontSize: 40, color: theme.palette.primary.main, mb: 1.5, opacity: 0.85 })} />
                  <Typography variant="body1" sx={(theme) => ({ fontWeight: 600, color: theme.palette.text.primary, mb: 0.5 })}>
                    Drag & drop your file here, or click to browse
                  </Typography>
                  <Typography variant="caption" sx={(theme) => ({ color: theme.palette.text.secondary })}>
                    Supports CSV, XLSX, XLS
                  </Typography>
                </>
              ) : (
                <Box sx={{ display: "flex", alignItems: "center", gap: 2, width: "100%", justifyContent: "center" }}>
                  <InsertDriveFileIcon sx={(theme) => ({ fontSize: 32, color: theme.palette.success.main })} />
                  <Box sx={{ textAlign: "left", maxWidth: "70%" }}>
                    <Typography
                      variant="body2"
                      sx={(theme) => ({ fontWeight: 600, color: theme.palette.text.primary, noWrap: true, overflow: "hidden", textOverflow: "ellipsis" })}
                    >
                      {file.name}
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={(theme) => ({ color: theme.palette.success.main, display: "block" })}
                    >
                      File loaded successfully • {(file.size / 1024).toFixed(1)} KB
                    </Typography>
                  </Box>
                  <Button
                    variant="text"
                    size="small"
                    sx={(theme) => ({
                      color: theme.palette.error.main,
                      fontWeight: 600,
                      zIndex: 3,
                      textTransform: "none",
                      "&:hover": { background: theme.palette.action.hover },
                    })}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setFile(null);
                    }}
                  >
                    Remove
                  </Button>
                </Box>
              )}
            </Box>

            {/* Legend indicators */}
            <Stack
              direction={{ xs: "row", md: "column" }}
              spacing={2}
              justifyContent="center"
              sx={(theme) => ({
                minWidth: "260px",
                p: 2,
                borderRadius: "12px",
                border: `1px solid ${theme.palette.divider}`,
                backgroundColor: theme.palette.background.paper,
              })}
            >
              <Typography
                variant="caption"
                sx={(theme) => ({ color: theme.palette.text.secondary, fontWeight: 700, textTransform: "uppercase", letterSpacing: "1px", mb: 0.5, display: { xs: "none", md: "block" } })}
              >
                Database Matching System
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                <Box
                  sx={(theme) => ({
                    background: theme.palette.mode === 'dark' ? 'rgba(16, 185, 129, 0.15)' : 'rgba(16, 185, 129, 0.15)',
                    border: `1px solid ${theme.palette.success.light}`,
                    color: theme.palette.success.main,
                    borderRadius: "6px",
                    px: 1.5,
                    py: 0.5,
                    fontSize: "11px",
                    fontWeight: 700,
                    textTransform: "uppercase",
                  })}
                >
                  Yes
                </Box>
                <Typography variant="body2" sx={(theme) => ({ color: theme.palette.text.secondary, fontSize: "12px" })}>
                  Closest Match Available
                </Typography>
              </Box>

              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                <Box
                  sx={(theme) => ({
                    background: theme.palette.mode === 'dark' ? 'rgba(245, 158, 11, 0.15)' : 'rgba(245, 158, 11, 0.15)',
                    border: `1px solid ${theme.palette.warning.light}`,
                    color: theme.palette.warning.main,
                    borderRadius: "6px",
                    px: 1.5,
                    py: 0.5,
                    fontSize: "11px",
                    fontWeight: 700,
                    textTransform: "uppercase",
                  })}
                >
                  No
                </Box>
                <Typography variant="body2" sx={(theme) => ({ color: theme.palette.text.secondary, fontSize: "12px" })}>
                  No Match Available
                </Typography>
              </Box>
            </Stack>
          </Box>

          <Box
            sx={(theme) => ({
              flex: 1,
              width: "100%",
              borderRadius: "12px",
              overflow: "hidden",
              border: `1px solid ${theme.palette.divider}`,
              background: theme.palette.background.paper,
              height: "calc(100% - 200px)",
              "& .ag-theme-quartz": {
                height: "100% !important",
              },
            })}
          >
            <AgGridReact
              className="ag-theme-quartz"
              onRowSelectionModelChange={(ids) => {
                const selectedIDs = new Set(ids);
                const selectedRows = newRowData.filter((row) =>
                  selectedIDs.has(row.id)
                );
                setSelectedRows(selectedRows);
              }}
              onGridReady={onGridReady}
              onFirstDataRendered={onFirstDataRendered}
              rowSelection="multiple"
              pagination={true}
              rowData={newRowData}
              defaultColDef={defaultColDef}
              columnDefs={ensureHeaderTooltip(columnFinal1)}
              checkboxSelection
              onRowSelected={handleRowSelection}
              frameworkComponents={frameworkComponents}
              onCellValueChanged={(event) => handleCellValueChanged(event)}
              suppressRowClickSelection={true}
            />
          </Box>
        </DialogContent>

        <DialogActions
          sx={(theme) => ({
            padding: "20px !important",
            borderTop: `1px solid ${theme.palette.divider}`,
            backgroundColor: theme.palette.background.paper,
          })}
        >
          {typeUser === typeConstant.admin &&
            matchDealerName &&
            matchDealerName?.length > 0 ? (
            <Button
              variant="contained"
              className={classes.fleetListNewButton}
              disabled={addButtonDisabled}
              onClick={handleAddBox}
              sx={{ borderRadius: "8px !important", textTransform: "capitalize !important" }}
            >
              {loadingFleetFile ? "Uploading..." : "Add"}
            </Button>
          ) : newRowData &&
            newRowData?.length > 0 &&
            typeUser === typeConstant.dealer &&
            dealerNameHeader?.dealerName !== newRowData[0]?.dealer ? (
            <Button
              variant="contained"
              className={classes.fleetListNewButton}
              disabled={addButtonDisabled}
              onClick={handleAddBox}
              sx={{ borderRadius: "8px !important", textTransform: "capitalize !important" }}
            >
              {loadingFleetFile ? "Uploading..." : "Add"}
            </Button>
          ) : (
            <Button
              variant="contained"
              className={classes.fleetListNewButton}
              disabled={addButtonDisabled}
              onClick={handleAddButton}
              sx={{ borderRadius: "8px !important", textTransform: "capitalize !important" }}
            >
              {loadingFleetFile ? "Uploading..." : "Add"}
            </Button>
          )}
          <Button
            href="#"
            variant="outlined"
            sx={(theme) => ({
              color: `${theme.palette.primary.main} !important`,
              borderColor: `${theme.palette.primary.main} !important`,
              fontWeight: "bold !important",
              borderRadius: "8px !important",
              textTransform: "capitalize !important",
              padding: "6px 16px !important",
              marginRight: "8px !important",
              transition: "all 0.3s ease !important",
              "&:hover": {
                borderColor: `${theme.palette.primary.dark} !important`,
                background: theme.palette.action.hover,
                boxShadow: theme.palette.mode === 'dark' ? "0 0 10px rgba(255,255,255,0.08) !important" : "0 0 10px rgba(32, 141, 233, 0.12) !important",
              },
            })}
            onClick={downloadCsv}
          >
            Download Sample File
          </Button>
          <Button
            variant="outlined"
            sx={(theme) => ({
              color: `${theme.palette.text.secondary} !important`,
              borderColor: `${theme.palette.divider} !important`,
              fontWeight: "bold !important",
              borderRadius: "8px !important",
              textTransform: "capitalize !important",
              padding: "6px 16px !important",
              transition: "all 0.3s ease !important",
              "&:hover": {
                borderColor: `${theme.palette.primary.main} !important`,
                background: theme.palette.action.hover,
              },
            })}
            onClick={handleClose}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        onClose={handleDealerNameClose}
        aria-labelledby="customized-dialog-title"
        open={openDealerName}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: (theme) => ({
            backgroundColor: theme.palette.background.paper,
            backgroundImage: "none",
            color: theme.palette.text.primary,
            borderRadius: "12px",
            border: `1px solid ${theme.palette.divider}`,
          }),
        }}
      >
        <DialogTitle
          id="customized-dialog-title"
          sx={(theme) => ({
            m: 0,
            p: 2,
            borderBottom: `1px solid ${theme.palette.divider}`,
          })}
        >
          <Typography
            variant="h6"
            component="span"
            sx={(theme) => ({ fontWeight: 700, color: theme.palette.primary.main })}
          >
            Dealer Name
          </Typography>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleDealerNameClose}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.text.secondary,
            "&:hover": { color: theme.palette.primary.main },
          })}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers sx={{ borderBottom: "none" }}>
          {matchDealerName && matchDealerName.length > 0 ? (
            <List
              sx={{
                columnCount: {
                  md: 3,
                  sm: 2,
                  xs: 1,
                },
                listStyleType: "auto",
                pl: 4,
              }}
            >
              {matchDealerName.map((item, index) => (
                <ListItem sx={{ display: "list-item" }} key={index}>
                  <ListItemText primary={item.dealerName} />
                </ListItem>
              ))}
            </List>
          ) : (
            <Typography variant="body2" sx={(theme) => ({ color: theme.palette.text.secondary })}>
              No dealers found.
            </Typography>
          )}
        </DialogContent>
      </Dialog>
      {openAdd && (
        <FleetUploadConformDialog
          close={() => setOpenAdd(false)}
          open={openAdd}
          setOpen={setOpenAdd}
          handleClose={() => setOpenAdd(false)}
          handleClick={handleAddButton}
          typeUser={typeUser}
          dealerNameHeader={dealerNameHeader}
        />
      )}
    </>
  );
};

